export const E_BIKE = {
  name: 'eBike',
  type_id: '1c27414e-df51-430e-8b4e-37a0fba81f1a'
}

const basicForm = {
  type: E_BIKE.name,
  type_id: E_BIKE.type_id,
  name: '',
  brand: '',
  brand_id: '',
  model: '',
  engine_brand: '',
  engine_brand_id: '',
  engine_model: '',
  color: '',
  maintenance_plan_id: null,
  tags: []
}

export const installDeviceForm = {
  ...basicForm,
  short_name: '',
  license_plate: '',
  is_customer: null,
  replace_entity_id: null,
  imei: '',
  odo: 0,
  first_name_customer: '',
  last_name_customer: '',
  email_customer: '',
  phone_customer: ''
}

export const presetsForm = {
  ...basicForm,
  preset_name: ''
}

export const TRACEFY_PRESET_LOCAL_STORAGE_KEY = 'TracefyPreset'

export type ExpansionPanelStateTypes = 'DISABLED' | 'ENABLED' | 'VALIDATED' | 'INVALIDATED'

export const expansionPanelStates = {
  DISABLED: 'DISABLED',
  ENABLED: 'ENABLED',
  INVALIDATED: 'INVALIDATED',
  VALIDATED: 'VALIDATED'
}

export const networkStates = {
  NETWORK_CONNECTED: 'CONNECTED',
  NETWORK_DISCONNECTED: 'DISCONNECTED'
}

export const gpsStates = {
  GPS_STRONG_CONNECTION: 'STRONG_CONNECTION',
  GPS_MEDIUM_CONNECTION: 'MEDIUM_CONNECTION',
  GPS_WEAK_CONNECTION: 'WEAK_CONNECTION'
}

export const batteryStates = {
  BATTERY_CONNECTED: 'BATTERY_CONNECTED',
  BATTERY_DISCONNECTED: 'BATTERY_DISCONNECTED'
}

const { DISABLED, ENABLED } = expansionPanelStates

export const expansionPanelDefaultState = [ENABLED, DISABLED, DISABLED, DISABLED]

export const rules = {
  step0: {
    replaceEntity: [(v: string) => !!v]
  },
  step1: {
    imei: [(v: string | null) => typeof v === 'string' && v.length === 15]
  },
  step2: {
    vehicleName: [(v: string) => !!v],
    frameNumber: [(v: string) => !!v],
    color: [(v: string) => !!v],
    brand: [(v: string) => !!v]
  },
  step3: {
    customerFirstName: [(v: string) => !!v],
    customerLastName: [(v: string) => !!v],
    customerEmail: [(v: string) => !!v,
      (v: string) => !v || /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,255})+$/.test(v)],
    customerPhone: [(v: string) => !!v]
  },
  presets: {
    presetName: [(v: string) => !!v]
  }
}
